import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Layers, Gavel } from 'lucide-react';
import ModernPage from './components/modern/ModernPage';
import LawyerPage from './components/lawyer/LawyerPage';
import LawyerPageVani from './components/lawyer/LawyerPageVani';
import './App.scss';

const Navigation = () => {
  const location = useLocation();
  const isV1 = location.pathname === '/v1';
  const isV2 = location.pathname === '/v2';
  const isV3 = location.pathname === '/v3' || location.pathname === '/';

  return (
    <nav className={`app-navigation ${isV3 ? 'lawyer-nav' : 'modern-nav'}`} style={{ padding: '0.5rem', gap: '0.5rem' }}>
      <Link
        to="/"
        className={`nav-link ${isV3 ? 'active' : ''}`}
        title="V3 - AI Lawyer"
        style={{ padding: '0.5rem', minWidth: 'auto', fontSize: '0.8rem' }}
      >
        <Gavel size={16} />
        <span style={{ marginLeft: '4px' }}>V3</span>
      </Link>
      <Link
        to="/v1"
        className={`nav-link ${isV1 ? 'active' : ''}`}
        title="V1 - Classic"
        style={{ padding: '0.5rem', minWidth: 'auto', fontSize: '0.8rem' }}
      >
        <Gavel size={16} />
        <span style={{ marginLeft: '4px' }}>V1</span>
      </Link>
      <Link
        to="/v2"
        className={`nav-link ${isV2 ? 'active' : ''}`}
        title="V2 - Modern"
        style={{ padding: '0.5rem', minWidth: 'auto', fontSize: '0.8rem' }}
      >
        <Layers size={16} />
        <span style={{ marginLeft: '4px' }}>V2</span>
      </Link>
    </nav>
  );
};

const App = () => {
  return (
    <Router>
      <div className="app-router-wrapper">
        <Navigation />
        <Routes>
          <Route path="/" element={<LawyerPageVani />} />
          <Route path="/v3" element={<LawyerPageVani />} />
          <Route path="/v1" element={<LawyerPage />} />
          <Route path="/v2" element={<ModernPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;